import uuidGenerate from 'react-uuid';

export const uuid = (): string => uuidGenerate();
